// Alpine
import Alpine from 'alpinejs';
import intersect from '@alpinejs/intersect'
import resize from '@alpinejs/resize'

window['Alpine'] = Alpine;
Alpine.plugin(intersect)
Alpine.plugin(resize)
Alpine.start()
